export const PURCHASE_TYPE_REMAINING_POOL = 48;



// WEBPACK FOOTER //
// ./src/constants/purchase.js